const formatMoney=(val)=> {
  if (val == null || val === '') return ''
  const num = Number(val)
  if (isNaN(num)) return val
  return num.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
export default formatMoney